import {any} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {BusinessCaseOnlineOfferResponseBody} from '../../../api/types/onlineOfferTypes';

type ReservationPriceFields = Partial<
  Pick<
    BusinessCaseOnlineOfferResponseBody,
    | 'upsell'
    | 'totalPriceWithVat'
    | 'totalPriceWithoutVat'
    | 'totalDiscountPriceWithVat'
    | 'totalDiscountPriceWithoutVat'
    | 'vehiclePriceWithVat'
    | 'vehiclePriceWithoutVat'
    | 'originalCarPriceWithVat'
    | 'originalCarPriceWithoutVat'
  >
>;

/**
 * Whether the offer carries any price at all. Both reservation cards drop
 * themselves entirely when it does not, so an offer without prices shows no
 * empty card rather than a blank grey box.
 */
export function hasReservationPrices(offer: ReservationPriceFields) {
  return any(isNotNilOrEmpty, [
    offer.upsell,
    offer.totalPriceWithVat,
    offer.totalPriceWithoutVat,
    offer.totalDiscountPriceWithVat,
    offer.totalDiscountPriceWithoutVat,
    offer.vehiclePriceWithVat,
    offer.vehiclePriceWithoutVat,
    offer.originalCarPriceWithVat,
    offer.originalCarPriceWithoutVat,
  ]);
}
